import { AdminAPI, getFragment, GraphQL, SharedAPI } from '@guestgoodie/graphql'
import { useMemo } from 'react'
import { useLingui } from '@lingui/react/macro'
import { useQuery } from '@apollo/client/react'
import ComboBox from '@/components/ui/ComboBox'

function optionFromDoor(door: GraphQL.IntegrationDoorFragmentFragment) {
  return {
    value: `${door.id}`,
    label: `${door.doorId} (${door.provider})`
  }
}

interface Props {
  value?: number | undefined
  onChange: (newValue?: number | null) => void
  name?: string
  invalid?: boolean
  disabled?: boolean
  readOnly?: boolean
}

export function SelectDoor({
  value,
  onChange,
  name,
  invalid,
  readOnly,
  disabled
}: Props) {
  const { t } = useLingui()

  const { data, loading } = useQuery(AdminAPI.integrationDoor.GET_ALL)

  const doors = getFragment(
    SharedAPI.integrationDoor.INTEGRATION_DOOR_FRAGMENT,
    data?.getAllIntegrationDoors
  )

  const options = useMemo(() => (doors ?? []).map(optionFromDoor), [doors])

  return (
    <ComboBox
      options={options}
      onChange={value => {
        const newValue = parseInt(value)

        if (isNaN(newValue)) onChange(null)
        else onChange(newValue)
      }}
      value={value?.toString() ?? ''}
      name={name}
      invalid={invalid}
      readOnly={readOnly}
      disabled={disabled}
      loading={loading}
      allowSearchValue={false}
      searchThreshold={0.2}
      placeholder={t`Select Door`}
      ariaLabel={t`Select Door`}
      searchText={t`Search Doors…`}
    />
  )
}
